import React, { useState } from 'react';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Header from './components/Header';
import Navigation from './components/Navigation';
import Dashboard from './components/Dashboard';
import Missions from './components/Missions';
import SocialFeed from './components/SocialFeed';
import Leaderboard from './components/Leaderboard';
import Rewards from './components/Rewards';
import Profile from './components/Profile';
import LandingPage from './components/LandingPage';
import AdminPage from './components/AdminPage';
import LoadingSpinner from './components/LoadingSpinner';
import MobileApp from './mobile/MobileApp';
import IssueReportDashboard from './components/IssueReportDashboard';

function AppContent() {
  const [activeTab, setActiveTab] = useState('dashboard');
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { user, loading } = useAuth();

  // Check if current path is admin or mobile
  const currentPath = window.location.pathname;
  const isAdminPath = currentPath === '/admin';
  const isMobilePath = currentPath === '/mobile';

  if (isAdminPath) {
    return <AdminPage />;
  }

  if (isMobilePath) {
    return <MobileApp />;
  }

  if (loading) {
    return <LoadingSpinner />;
  }

  // Show landing page if user is not authenticated
  if (!user) {
    return <LandingPage />;
  }

  const renderContent = () => {
    switch (activeTab) {
      case 'dashboard':
        return <Dashboard />;
      case 'missions':
        return <Missions />;
      case 'social':
        return <SocialFeed />;
      case 'leaderboard':
        return <Leaderboard />;
      case 'rewards':
        return <Rewards />;
      case 'profile':
        return <Profile />;
      case 'issues':
        return <IssueReportDashboard />;
      default:
        return <Dashboard />;
    }
  };

  return (
    <div className="min-h-screen mobile-container bg-gray-50 overflow-x-hidden">
      <Header 
        onMenuClick={() => setIsMobileMenuOpen(true)}
        onProfileClick={() => setActiveTab('profile')}
      />
      
      <Navigation
        activeTab={activeTab}
        onTabChange={setActiveTab}
        isMobileMenuOpen={isMobileMenuOpen}
        onMobileMenuClose={() => setIsMobileMenuOpen(false)}
      />

      {/* Main Content */}
      <main className="lg:ml-64 pt-8 pb-20 lg:pb-8 overflow-x-hidden">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 overflow-x-hidden">
          <div className="mobile-scroll">
            {renderContent()}
          </div>
        </div>
      </main>
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}